module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"confirmEdiSent":"EDI has already been sent. Are you sure you want to change address?","confirmDatesSet":"ATD or ATA has already been set. Are you sure you want to change address?"},"no":{"confirmEdiSent":"EDI er allerede sendt. Are you sure you want to change address?","confirmDatesSet":"ATD eller ATA er allerede satt. Are you sure you want to change address?"}}')
  delete Component.options._Ctor
}
